/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getNewsPublicDetail } from "../../Api";
import "./News.scss";
import { setTitlePage } from "../../Functions";
import { Header } from "./Header";

const NewsPublic = () => {

  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [news, setNews] = useState({
    title: '',
    body: '',
    image: '',
    urlbase: '',
    excerpt: ''
  });

  const getPost = async () => {
    const _response: any = await getNewsPublicDetail(slug);
    if (_response.status) {
      setNews(_response.data);
    }
    setLoading(false);
  }

  useEffect(() => {
    getPost();
    setTitlePage('Noticia');
  }, []);

  return (
    <>
      <style>
        {`
          .align-center-important {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
        `}
      </style>
      {loading && <div className="align-center-important" style={{ marginTop: '20px' }}> <h4>Cargando noticia... </h4></div>}
      {!loading && <><Header /><div className="row">

        <div className="card">
          <div className="card-header">
            <span className="card-title fw-bold text-dark" style={{ fontSize: '2rem' }}>{news.title}</span>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-4">
                <img src={news.image} className="d-block w-100" style={{ borderRadius: '40px' }} alt='' />
              </div>
              <div className="col-md-8">
                <span style={{ fontSize: '1.5rem' }}> {news.excerpt} </span>
              </div>
              <div className="col-md-12" style={{ marginTop: '20px' }}>
                <div dangerouslySetInnerHTML={{ __html: news.body }} />
              </div>
            </div>
          </div>
        </div>
      </div></>}
    </>
  )
}

export default NewsPublic
